/* When the running copy was built. Put in at build time by `define` in
 * vite.config.ts; empty wherever that did not run, such as the test bundle. */

declare const __BUILD_TIME__: string | undefined;

export const BUILD_TIME: string = typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : '';
